import React from 'react';
import { JSErrorBoundary } from '@atlassian/jira-error-boundaries/src/ui/js-error-boundary/JSErrorBoundary.tsx';
import Placeholder from '@atlassian/jira-placeholder/src/index.tsx';
import { lazyAfterPaint } from '@atlassian/react-loosely-lazy';
import type { NudgeInactiveConfluenceUser } from './index.tsx';

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const NudgeInactiveConfluenceUserFlagContainer = lazyAfterPaint<typeof NudgeInactiveConfluenceUser>(
	() =>
		import(/* webpackChunkName: "async-nudge-inactive-confluence-user-flag" */ './index').then(
			(module) => module.NudgeInactiveConfluenceUser,
		),
	{ ssr: false },
);

export const AsyncNudgeInactiveConfluenceUserFlagContainer = () => (
	<JSErrorBoundary
		id="nudgeInactiveConfluenceUserFlag"
		packageName="nudgeInactiveConfluenceUser"
		fallback="unmount"
		teamName="cc-flywheel-adoption"
	>
		<Placeholder name="nudge-inactive-confluence-user-flag" fallback={null}>
			<NudgeInactiveConfluenceUserFlagContainer />
		</Placeholder>
	</JSErrorBoundary>
);
